module.exports = __webpack_public_path__ + "static/media/upload_success.56bb6a76.png";